export var LeanTypes;
(function (LeanTypes) {
    LeanTypes["big_string"] = "big_string";
    LeanTypes["text"] = "text";
    LeanTypes["small_string"] = "small_string";
    LeanTypes["integer"] = "integer";
    LeanTypes["double"] = "double";
    LeanTypes["boolean"] = "boolean";
    LeanTypes["string_enum"] = "string_enum";
    LeanTypes["shape"] = "shape";
    LeanTypes["array"] = "array";
    LeanTypes["slot"] = "slot";
    LeanTypes["svg"] = "svg";
    LeanTypes["color_picker"] = "color_picker";
    LeanTypes["font_picker"] = "font_picker";
    LeanTypes["link"] = "link";
})(LeanTypes || (LeanTypes = {}));
const leanTypesEnumKeys = ((obj) => {
    return Object.keys(obj).filter(k => Number.isNaN(+k))[0];
})(LeanTypes);
//# sourceMappingURL=types.js.map